mutation UpdateInstructorLinkTags(
  $scenarioId: ID!
  $originId: ID!
  $input: UpdateInstructorLinkTagsInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    updateInstructorLinkTags(input: $input) {
      commited
      validations {
        ... on InvalidInput {
          code
          meta
        }
      }
    }
  }
}
